import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import application from "@/store/application.js";
import paddyFields from "@/store/modules/paddyfields.js";
import paddyFieldHistories from "@/store/modules/paddyfieldhistories.js";
import paddyFieldAreas from "@/store/modules/paddyfieldareas.js";
import seasons from "@/store/modules/seasons.js";
import items from "@/store/modules/items.js";
import workHistories from "@/store/modules/workhistories.js";
import settings from "@/store/modules/settings.js";
import weather from "@/store/modules/weather.js";
import sensors from "@/store/modules/sensors.js";
import notifications from "@/store/modules/notifications.js";
import account from "@/store/modules/account.js";
import management from "@/store/modules/management.js";
import users from "@/store/modules/users.js";
import area from "@/store/modules/area.js";
import weatherSettings from "@/store/modules/weatherSettings.js";
import globalworkhistories from "@/store/modules/globalworkhistories.js";
import informations from "@/store/modules/informations.js";
import logs from "@/store/modules/logs.js";
import brands from "@/store/modules/brands.js";
import payment from "@/store/modules/payment.js";
import inquiry from "@/store/modules/inquiry.js";
import seasonHistories from "@/store/modules/seasonhistories.js";
import location from "@/store/modules/location.js";
import workprogress from "@/store/modules/workprogress.js";
import maintenance from "@/store/modules/maintenance.js";
import landmarks from "@/store/modules/landmarks.js";
import watergate from "@/store/modules/watergate.js";
import accesslogs from "@/store/modules/accesslogs.js";
import archives from "@/store/modules/archives.js";
import paymentlogin from "@/store/modules/paymentlogin.js";

export default new Vuex.Store({
  modules: {
    application,
    paddyFields,
    paddyFieldHistories,
    seasons,
    items,
    workHistories,
    settings,
    weather,
    sensors,
    notifications,
    account,
    management,
    users,
    area,
    weatherSettings,
    globalworkhistories,
    informations,
    logs,
    brands,
    payment,
    inquiry,
    seasonHistories,
    location,
    workprogress,
    paddyFieldAreas,
    maintenance,
    landmarks,
    watergate,
    accesslogs,    
    archives,
    paymentlogin,
  }
});
